import picVideo from './pic&video'
export default {
  components: { picVideo },
  data() {
    return {
      rowData: {},
      viewType: '',
      picVideoVisible: false
    }
  },
  methods: {
    showDialog(rowData, type) {
      this.rowData = rowData;
      this.viewType = type;
      this.picVideoVisible = true;
    },
    // 显示查看图片
    showDetailBtn(rowData) {
      if (!rowData.photoUrls || !rowData.photoUrls.length) {
        return false;
      }else{
        return true;
      }
    }
  }
}